<template>
  <div class="oneYuan" id="container">
    <img src="../../assets/images/activity/1yuan365/img_01.jpg" alt width="100%" />
    <img src="../../assets/images/activity/1yuan365/img_02.jpg" alt width="100%" />
    <img src="../../assets/images/activity/1yuan365/img_03.jpg" alt width="100%" />
    <section class="form">
      <form action="###">
        <h1>全新炒股战法 免费领取</h1>
        <div class="form-item">
          <input type="tel" name id placeholder="手机号" v-model="mobile" />
        </div>
        <div class="form-item form-item-yzm">
          <input type="text" name id placeholder="验证码" v-model="captcha" />
          <a
            href="###"
            class="btn-yzm"
            @click="sendCaptcha"
            :class="sendSuccess?'disabled':''"
          >{{yzmText}}</a>
        </div>
        <p class="rule" @click="selectRules=!selectRules" :class="selectRules?'selected':''">
          阅读并同意
          <a href="#">《软件产品许可使用协议》</a>中的各项条款，同意接收软件相关服务(短信&电话)
        </p>
        <button class="btn-submit" @click="checkForm">立即领取</button>
      </form>
    </section>
    <img src="../../assets/images/activity/1yuan365/img_05.jpg" alt width="100%" />
    <img src="../../assets/images/activity/1yuan365/img_06.jpg" alt width="100%" />
    <img
      src="../../assets/images/activity/1yuan365/img_07.jpg"
      alt
      width="100%"
      style="margin-bottom:0.64rem"
    />
    <img src="../../assets/images/activity/1yuan365/img_09.jpg" alt width="100%" />
    <img src="../../assets/images/activity/1yuan365/img_10.jpg" alt width="100%" />
    <img src="../../assets/images/activity/1yuan365/img_11.jpg" alt width="100%" />
    <div class="footer-submit">
      <a href="###" class="btn-submit btn-submit-red" @click="scrollTo">免费领取</a>
    </div>
    <footer class="footer">
      <p>活动须知：大智慧指标-四维战法为大智慧365（电脑端）炒股指标，功能自领取日起15天有效,尽快用领取的手机号登录使用哦！本活动时间9月30日-12月31日</p>
      <p>
        投资有风险 入市需谨慎 从事证券投资或期货交易，请通过合法证券期货经营机构进行。 合法机构名单可到中国证监会网站（www.csrc.gov.cn）查询
        <br />大智慧股份有限公司对本活动拥有解释权
      </p>
    </footer>
    <div class="tooltip" v-show="errorTip!==''">{{errorTip}}</div>
  </div>
</template>

<script>
export default {
  data: function() {
    return {
      selectRules: true,
      sendSuccess: false,
      yzmText: "发送验证码",
      mobile: "",
      captcha: "",
      errorTip: "",
      params: {
        productId: 333,
        month: 15
      }
    };
  },
  created() {},
  methods: {
    scrollTo() {
      window.scrollTo(0, 400);
    },
    checkForm() {
      if (!this.selectRules) {
        this.toggleTip("请勾选许可使用协议");
        return false;
      }
      if (!this.mobile) {
        this.toggleTip("请输入手机号码");
        return false;
      }
      if (!this.$validate.checkPhone(this.mobile)) {
        this.toggleTip("手机号码格式不正确");
        return false;
      }
      if (!this.captcha) {
        this.toggleTip("请输入验证码");
        return false;
      }
      this.params.mobile = this.mobile;
      this.params.captcha = this.captcha;
      this.$post("/activity/free333Save", this.params)
        .then(response => {
          if (response.code === 0) {
            this.$router.push("/activity/free333Success");
          } else {
            this.toggleTip(response.msg);
          }
        })
        .catch(err => {
          this.toggleTip("网络异常，请稍后重试。");
        });
    },
    sendCaptcha() {
      if (!this.mobile) {
        this.toggleTip("请输入手机号码");
        return false;
      }
      if (!this.$validate.checkPhone(this.mobile)) {
        this.toggleTip("手机号码格式不正确");
        return false;
      }
      this.params.mobile = this.mobile;
      this.$post("/activity/free333Sms", this.params)
        .then(response => {
          if (response.code === 0) {
            var secends = 60,
              ts = this,
              timer;
            this.sendSuccess = true;
            this.yzmText = "已发送" + secends + "s";
            timer = setInterval(() => {
              secends--;
              this.yzmText = "已发送" + secends + "s";
              if (secends < 0) {
                this.yzmText = "重新发送";
                this.sendSuccess = false;
                clearInterval(timer);
              }
            }, 1000);
          } else {
            this.toggleTip(response.msg);
          }
        })
        .catch(err => {
          this.toggleTip("网络异常，请稍后重试。");
        });
    },
    toggleTip(msg) {
      this.errorTip = msg;
      setTimeout(() => {
        this.errorTip = "";
      }, 1500);
    }
  }
};
</script>

<style lang="scss" scoped>
body {
  min-width: 100%;
}
#container {
  max-width: 750px;
  margin: 0 auto;
  width: 100%;
}
html {
  font-size: 50px;
}
@media screen and (min-width: 320px) {
  html {
    font-size: 42.7px;
  }
}
@media screen and (min-width: 360px) {
  html {
    font-size: 48px;
  }
}
@media screen and (min-width: 375px) {
  html {
    font-size: 50px;
  }
}
@media screen and (min-width: 414px) {
  html {
    font-size: 55.2px;
  }
}
body,
button,
input,
select,
textarea {
  font: 12px/1.4 "Helvetica Neue", Helvetica, Arial, "PingFang SC",
    "Hiragino Sans GB", "Heiti SC", "Microsoft YaHei", sans-serif;
}
h1,
h2,
h3,
h4,
h5,
h6,
b,
strong {
  font-weight: normal;
}
button,
input,
select,
textarea {
  padding: 0;
  background: none;
  border: 0;
  font-size: inherit;
  -webkit-appearance: none;
  appearance: none;
}
textarea:focus,
input:focus,
button:focus {
  outline: 0;
}
i {
  font-style: normal;
}
a {
  text-decoration: none;
}
img {
  display: block;
  margin: 0 auto;
}
.flex {
  /* 老版本语法: Safari, iOS, Android browser, older WebKit browsers. */ /* 老版本语法: Firefox (buggy) */ /* 混合版本语法: IE 10 */ /* 新版本语法: Chrome 21+ */
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex; /* 新版本语法: Opera 12.1, Firefox 22+ */
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
}
.flex > * {
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
}
.oneYuan {
  background: #13084e;
  color: #fff;
  input::-webkit-input-placeholder {
    color: #8a92d3;
  }
  .form {
    padding: 0.6rem 1.16rem 1rem;
    h1 {
      line-height: 10rem;
      overflow: hidden;
      height: 0.5rem;
      background: url("../../assets/images/activity/1yuan365/title.png")
        no-repeat 0 0;
      width: 4.8rem;
      margin: 0 auto 0.24rem;
      background-size: cover;
      -webkit-background-size: cover;
    }
    &-item {
      background: #fff;
      padding: 0.2rem 0.5rem;
      margin-bottom: 0.28rem;
    }
    &-item-yzm {
      margin-right: 2rem;
      position: relative;
    }
    .btn-yzm {
      position: absolute;
      right: -2rem;
      top: 0;
      line-height: 0.8rem;
      height: 0.8rem;
      background: #7528d2;
      text-align: center;
      font-size: 0.28rem;
      color: #fff;
      width: 1.8rem;
      &.disabled {
        background: #ccc;
        color: #888;
        pointer-events: none;
      }
    }
    input {
      display: block;
      line-height: 0.4rem;
      height: 0.4rem;
      font-size: 0.34rem;
      width: 100%;
    }
    .rule {
      font-size: 0.22rem;
      color: #999;
      padding-left: 0.6rem;
      position: relative;
      a {
        color: #ee5d60;
      }
      &:before {
        content: "";
        position: absolute;
        left: 0.04rem;
        top: 0;
        width: 0.38rem;
        height: 0.38rem;
        border-radius: 50%;
        border: 1px solid #fff;
      }
      &.selected {
        &:before {
          background: #fff;
        }
        &:after {
          content: "";
          position: absolute;
          left: 0.12rem;
          top: 0.1rem;
          width: 0.2rem;
          height: 0.12rem;
          border-left: 0.04rem solid #13084e;
          border-bottom: 0.04rem solid #13084e;
          border-radius: 0 0 0 0.04rem;
          transform: rotate(-45deg);
          -webkit-transform: rotate(-45deg);
          -ms-transform: rotate(-45deg);
        }
      }
    }
  }
  .footer-submit {
    padding: 0.9rem 1.2rem;
  }
  .btn-submit {
    display: block;
    width: 100%;
    line-height: 0.9rem;
    height: 0.9rem;
    font-size: 0.4rem;
    color: #fff;
    border: 1px solid #fff;
    margin-top: 0.5rem;
    text-align: center;
  }
  .btn-submit-red {
    background: #ee5d60;
    border-color: #ee5d60;
    margin: 0;
  }
  .footer {
    background: #fff;
    padding: 0.3rem 0.24rem;
    p {
      font-size: 0.24rem;
      color: #999;
      margin-bottom: 0.3rem;
    }
  }
  .tooltip {
    position: fixed;
    top: 50%;
    left: 50%;
    padding: 0.2rem 0.6rem;
    font-size: 0.3rem;
    color: #fff;
    border-radius: 0.1rem;
    background: rgba(0, 0, 0, 0.5);
    z-index: 10;
    transform: translate(-50%, -50%);
    -webkit-transform: translate(-50%, -50%);
    -ms-transform: translate(-50%, -50%);
    white-space: nowrap;
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/activity/Free333.vue